import i18n from "../i18n";

const FileDocument = (app) => {
  app
    .post("/file-documents/save/:id?", async ({ api, flash, req, res }) => {
      const { body, files, params } = req;
      if (params.id) {
        delete body.file;
        await api(`widget-file-document/${params.id}`, {
          method: "PUT",
          body,
          files,
        });
      } else {
        await api("widget-file-document", {
          method: "POST",
          body,
          files,
        });
      }

      flash(
        "success",
        i18n.t("coaching-portal:fileDocumentActions.successfullySaved")
      );

      res.refreshWith(
        { modal: "", file: "", submited: true },
        { url: "back", hash: "#_" }
      );
    })
    .get("/files/delete/:id", async ({ api, flash, req, res }) => {
      const { id } = req.params;

      await api(`widget-file-document/${id}`, {
        method: "DELETE",
      });

      flash(
        "success",
        i18n.t("coaching-portal:fileDocumentActions.successfullyRemoved")
      );

      res.backDontScroll();
    })
    .post("/files/reorder", async ({ api, assert, flash, req, res }) => {
      const { body } = req;
      assert(
        body.orderedFileDocuments,
        400,
        i18n.t("coaching-portal:fileDocumentActions.provideOrderedFiles")
      );

      await api("widget-file-document-reorder", {
        method: "PUT",
        body,
      });

      flash(
        "success",
        i18n.t("coaching-portal:fileDocumentActions.successfullyReordered")
      );
      res.backDontScroll();
    })

    .post("/files/status/:id", async ({ api, assert, flash, req, res }) => {
      const {
        body: { status },
        params: { id },
      } = req;
      const verbs = {
        draft: "unpublish",
        published: "publish",
      };

      assert(
        status,
        400,
        i18n.t("coaching-portal:fileDocumentActions.statusRequired")
      );
      assert(
        id,
        400,
        i18n.t("coaching-portal:fileDocumentActions.fileIdRequired")
      );

      const verb = verbs[status];

      await api(`widget-file-document/${id}`, {
        method: "PUT",
        body: { status },
      });

      flash(
        "success",
        i18n.t("coaching-portal:fileDocumentActions.successfullyVerbed", {
          verb,
        })
      );

      res.refreshWith({}, { url: "back", hash: "#_" });
    });
};

export default FileDocument;
